import React, { useState } from "react";
import Navbar from "../../components/Navbar/Navbar";
import { Table } from "antd";
import { UseGetRequest } from "../../utils/api/ApiRequests";
import { getIsAdminLogin, getEmployeeId } from "../../utils/Common";
import * as XLSX from 'xlsx';

export default function LeaveCredit() {
  const isAdminLogin = getIsAdminLogin();
  const employeeId = getEmployeeId();
  const currentDate = new Date();
  const [tableData, setTableData] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [searchTerm, setSearchTerm] = useState(null);

  const [filterConfig, setFilterConfig] = useState({
    // is_updated: false,
    employee_id: isAdminLogin ? "" : employeeId,
    year: currentDate.getFullYear(),
    term: "",
  });


  const handleSearch = (e) => {
    if (e.key === "Enter") {
      setFilterConfig((prev) => ({ ...prev, term: searchTerm }));
    }
  };

  const tableColumns = [
    {
      title: "Employee",
      key: "employee_name",
      dataIndex: "employee_name",
    },
    {
      title: "Sick Leave",
      key: "sick_leave_balance",
      dataIndex: "sick_leave_balance",
    },
    {
      title: "Vacation Leave",
      key: "vacation_leave_balance",
      dataIndex: "vacation_leave_balance",
    },
  ];

  function exportToExcel () {
      const excelData = [tableColumns.map((col) => col.title)]; // insert header titles first
      // populate excel data
      tableData.forEach((data) => {
        let tempArray = tableColumns.map((col) => data[col.key])
        excelData.push(tempArray)
      })
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.aoa_to_sheet(excelData);
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      const excelBlob = new Blob([XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })], { type: 'application/octet-stream' });
      const excelUrl = URL.createObjectURL(excelBlob);
      const downloadAnchor = document.createElement('a');
      downloadAnchor.href = excelUrl;
      downloadAnchor.download = 'Employee Leave.xlsx';
      downloadAnchor.click();
      setTimeout(() => {
        URL.revokeObjectURL(excelUrl);
      }, 100);
  }

  React.useEffect(() => {
    async function fetchTableData() {
      setIsFetching(true);
      setTableData([]);
      const response = await UseGetRequest(
        "employee_leaves/get_leave_credit",
        filterConfig
      );
      if (response.data) {
        setTableData(response.data.leave_credits);
      }
      // if (response.data) {
      //     const res = response.data;

      //     // Define headers
      //     const headers = ["Employee", "Period"];
      //     res.map((data) => {
      //         const headerName = `${data.description} (${data.maximum_days})`;
      //         headers.push(headerName);
      //         return headerName;
      //     });

      //     // Flatten and format data
      //     const mergedArr = res.flatMap((data) =>
      //         data.employee_leaves.map((emp) => ({
      //             employee_id: emp.employee_id,
      //             Employee: emp.employee_name,
      //             Period: `${moment(emp.validity_from).format('MMM D, YYYY')} - ${moment(emp.validity_to).format('MMM D, YYYY')}`,
      //             [`${data.description} (${data.maximum_days})`]: emp.remaining,
      //         }))
      //     );

      //     // Group by employee_id and merge objects
      //     const mergedObject = mergedArr.reduce((result, obj) => {
      //         const id = obj.employee_id;
      //         result[id] = { ...result[id], ...obj };
      //         return result;
      //     }, {});

      //     // Sort by employee name
      //     const finalArray = Object.values(mergedObject).sort((a, b) =>
      //         a.Employee.localeCompare(b.Employee)
      //     );

      //     const tableCols = Object.keys(finalArray[0]).filter((key) => key !== 'employee_id');
      //     setTableColumn(tableCols);
      //     setTableData(finalArray);
      // }
      setIsFetching(false);
    }

    fetchTableData();
  }, [filterConfig]);

  return (
    <Navbar
    activeNav="leave-credit"
      pageTitle="Employee Leave Credits"
      searchable
      setSearchQuery={(e) => setSearchTerm(e)}
      onSearch={handleSearch}
      searchPlaceholder="employee"
      noButton
      isManager
      withYearFilter
      onYearChange={(e) =>
        setFilterConfig((prev) => ({ ...prev, year: e.format("YYYY") }))
      }
      pageDownloadButtonTitle="Download Excel" 
      isDownloadBtn
      onClickDownloadButton = {exportToExcel}
    >
      <Table
        className="mt-4"
        rowKey="id"
        columns={tableColumns}
        dataSource={tableData}
        loading={isFetching}
      />
    </Navbar>
  );
}
